import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { hidden: Boolean }

  connect() {
    if (this.hiddenValue) return
    requestAnimationFrame(() => {
      this.element.classList.remove("header-search-hidden")
      this.element.classList.add("header-search-visible")
    })
  }

  navigate(event) {
    if (this.hiddenValue) return
    event.preventDefault()
    this.element.classList.add("header-search-hidden")
    window.setTimeout(() => {
      if (window.Turbo?.visit) {
        window.Turbo.visit(this.element.getAttribute("href"))
      } else {
        window.location.assign(this.element.getAttribute("href"))
      }
    }, 320)
  }
}
